export const siteConfig = {
  name: "Avior TV",
  description: null,
  theme: "avior",
  layout: "vertical",
  // semi-box, horizontal, vertical
  hideSideBar: false,
  sidebarType: "module",
  // popover, classic, module
  sidebarColor: null,
  navbarType: "sticky",
  // sticky, floating, static
  footerType: "static",
  // sticky,  static, hidden
  sidebarBg: "none",
  radius: 0.5,
};
